import { resolveAuthenticatedHeaders } from '@/utils/requestContext.js';

const API_BASE = String(import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
const ENDPOINT = `${API_BASE}/api/facturas/afip-credentials`;

async function request(method, body) {
  const response = await fetch(ENDPOINT, {
    method,
    headers: resolveAuthenticatedHeaders(body ? { 'Content-Type': 'application/json' } : {}),
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload?.ok) throw new Error(payload?.message || 'No se pudo procesar la configuración AFIP.');
  return payload.data;
}

const encodeFile = async (file) => {
  if (!file) return null;
  const bytes = new Uint8Array(await file.arrayBuffer());
  let binary = '';
  const step = 0x8000;
  for (let index = 0; index < bytes.length; index += step) binary += String.fromCharCode(...bytes.subarray(index, index + step));
  return { name: file.name, contentBase64: btoa(binary) };
};

export const getAfipCredentialsStatus = () => request('GET');
export const saveAfipCredentials = async ({ certificateFile, privateKeyFile }) => request('PUT', {
  certificate: await encodeFile(certificateFile),
  privateKey: await encodeFile(privateKeyFile),
});
